(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function initReveal() {
    var els = document.querySelectorAll('[data-rh-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    document.documentElement.classList.add('rh-js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGlow(root) {
    var btns = root.querySelectorAll('.rh-gp__btn');
    var panels = root.querySelectorAll('[data-gp-panel]');
    function pick(btn) {
      btns.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      root.style.setProperty('--gp-color', btn.getAttribute('data-color'));
      root.setAttribute('data-speed', btn.getAttribute('data-speed') || 'medium');
      var idx = btn.getAttribute('data-panel');
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-gp-panel') !== idx; });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = btns[(i + 1) % btns.length];
        if (k === 'ArrowLeft' || k === 'ArrowUp') n = btns[(i - 1 + btns.length) % btns.length];
        if (n) { e.preventDefault(); pick(n); n.focus(); }
      });
    });
    if (btns[0]) pick(btns[0]);
  }

  function initCountdown(el) {
    var parts = (el.getAttribute('data-rh-countdown') || '').split('-');
    if (parts.length !== 3) return;
    var end = new Date(+parts[0], +parts[1] - 1, +parts[2], 0, 0, 0).getTime();
    var d = el.querySelector('[data-cd="d"]'), h = el.querySelector('[data-cd="h"]'), m = el.querySelector('[data-cd="m"]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.hidden = true; return false; }
      var mins = Math.floor(diff / 60000);
      if (d) d.textContent = pad(Math.floor(mins / 1440));
      if (h) h.textContent = pad(Math.floor((mins % 1440) / 60));
      if (m) m.textContent = pad(mins % 60);
      el.hidden = false;
      return true;
    }
    if (tick()) setInterval(tick, 30000);
  }

  ready(function () {
    initReveal();
    document.querySelectorAll('[data-rh-glow]').forEach(initGlow);
    document.querySelectorAll('[data-rh-countdown]').forEach(initCountdown);
  });
})();
